import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useOption } from "../../context/OptionContext";
import { CiSearch } from "react-icons/ci";

import { FiRefreshCw } from "react-icons/fi";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import MaxPainChart from "../MaxPainChart/MaxPainChart";
import { FaSpinner } from "react-icons/fa6";
import useLocalSearch from "../../hooks/useLocalSearch";

// import { useStockName } from "../../context/StockNameContext";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import "./MaxPain.css";

import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const MaxPain = () => {
  const {
    fetchBySymbol,
    loading,
    error,
    pcr,
    meta,
    expiries,
    optionData,
    selectedExpiry,
    setSelectedExpiry,
    setExpiry,
    fetchByIndex,
  } = useOption();
  const {
    query: localSearch,
    setQuery: setLocalSearch,
    equityResults: localEquityResults,
    loading: localSearchLoading,
    clearResults: clearLocalResults,
  } = useLocalSearch();
  const [searchText, setSearchText] = useState("");
  const [symbol, setSymbol] = useState("");
  const [activeSecurityId, setActiveSecurityId] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [activeSymbol, setActiveSymbol] = useState("");
  const [lastFetchType, setLastFetchType] = useState(null);
  const [selectDropdown, setSelectDropdown] = useState(false);
  const [userTriggered, setUserTriggered] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState("");
  const [contract, setContract] = useState("");
  const { stockName, getNameBySymbol } = useMarketIndicators();
  const [results, setResults] = useState([]);

  //   const getPlaceholder = () => {
  //     if (window.matchMedia("(max-width: 600px)").matches) {
  //       return "Search";
  //     }
  //     return "Search Symbol";
  //   };
  //   const [placeholder, setPlaceholder] = useState(getPlaceholder());
  const nseIndices = [
    "NIFTY",
    "BANKNIFTY",
    "FINNIFTY",
    "MIDCPNIFTY",
    "NIFTYIT",
    "NIFTYAUTO",
    "NIFTYPHARMA",
    "NIFTYMETAL",
    "NIFTYFMCG",
    "NIFTYREALTY",
    "NIFTYMEDIA",
    "NIFTYENERGY",
  ];

  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter" && searchText.trim()) {
  //     setSymbol(searchText.trim().toUpperCase());
  //     const val = searchText.trim().toUpperCase();
  //     setActiveSymbol(val);
  //     setLastFetchType("symbol");
  //     setSearchText("");
  //     setSelectedIndex("");
  //     setSelectDropdown(false);
  //     fetchBySymbol(val);
  //   }
  // };
  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      clearLocalResults();
    }
  };
  // const handleIndexSelect = (e) => {
  //   const indexSymbol = e.target.value;
  //   console.log("Index Symbol", indexSymbol);
  //   setContract(indexSymbol);
  //   if (!indexSymbol) return;

  //   setSearchText("");
  //   setSelectedIndex(indexSymbol);
  //   setActiveSymbol(indexSymbol);
  //   setLastFetchType("index");

  //   setSelectDropdown(true);
  //   fetchByIndex(indexSymbol);
  // };
  const handleIndexSelect = async (e) => {
    const indexSymbol = e.target.value;

    if (!indexSymbol) return;

    setContract(indexSymbol);
    setSelectedIndex(indexSymbol);
    setActiveSymbol(indexSymbol);
    setLastFetchType("index");
    setSelectDropdown(true);

    // Index does not use stock security ID
    setActiveSecurityId(null);

    setLocalSearch("");
    setSymbol("");
    clearLocalResults();

    await fetchByIndex(indexSymbol);
  };

  console.log("Pcr data", pcr);

  const builtUpStyles = (signal) => {
    switch (signal) {
      case "LB":
        return { bg: "#d4f7e6", color: "#008A3E" };
      case "SB":
        return { bg: "#ffd4d4", color: "#C53030" };
      case "SC":
        return { bg: "#dce8ff", color: "#0047FF" };
      case "LW":
        return { bg: "#ffeac7", color: "#C68A14" };
      default:
        return { bg: "#f2f2f2", color: "#444" };
    }
  };
  function getBuiltUp(changeInOI, priceChange) {
    if (changeInOI > 0 && priceChange > 0) return "LB"; // Long Built-Up
    if (changeInOI > 0 && priceChange < 0) return "SB"; // Short Built-Up
    if (changeInOI < 0 && priceChange > 0) return "SC"; // Short Covering
    if (changeInOI < 0 && priceChange < 0) return "LW"; // Long Unwinding
    return "-";
  }
  const oc = optionData?.data?.oc || {};
  const rows = Object.keys(oc)
    .map((strike) => {
      const ce = oc[strike]?.ce;
      const pe = oc[strike]?.pe;

      // -------- CALL --------
      const ceOIChange = ce?.previous_oi != null ? ce.oi - ce.previous_oi : 0;

      const ceOIPercent =
        ce?.previous_oi > 0
          ? +(((ce.oi - ce.previous_oi) / ce.previous_oi) * 100).toFixed(2)
          : 0;

      const ceLtpPercent =
        ce?.previous_close_price > 0
          ? +(
              ((ce.last_price - ce.previous_close_price) /
                ce.previous_close_price) *
              100
            ).toFixed(2)
          : 0;

      // -------- PUT --------
      const peOIChange = pe?.previous_oi != null ? pe.oi - pe.previous_oi : 0;

      const peOIPercent =
        pe?.previous_oi > 0
          ? +(((pe.oi - pe.previous_oi) / pe.previous_oi) * 100).toFixed(2)
          : 0;

      const peLtpPercent =
        pe?.previous_close_price > 0
          ? +(
              ((pe.last_price - pe.previous_close_price) /
                pe.previous_close_price) *
              100
            ).toFixed(2)
          : 0;

      return {
        strike: Number(strike),

        CE: ce
          ? {
              oi: ce.oi,
              oiChange: ceOIChange,
              oiPercent: ceOIPercent,
              volume: ce.volume,
              iv: ce.implied_volatility,
              ltp: ce.last_price,
              ltpPercent: ceLtpPercent, // ✅ NEW
            }
          : null,

        PE: pe
          ? {
              oi: pe.oi,
              oiChange: peOIChange,
              oiPercent: peOIPercent,
              volume: pe.volume,
              iv: pe.implied_volatility,
              ltp: pe.last_price,
              ltpPercent: peLtpPercent, // ✅ NEW
            }
          : null,
      };
    })
    // ✅ lowest → highest strike (NSE style)
    .sort((a, b) => a.strike - b.strike);
  const totCEVol = rows.reduce((sum, row) => sum + (row.CE?.volume || 0), 0);

  const totPEVol = rows.reduce((sum, row) => sum + (row.PE?.volume || 0), 0);

  function calculateMaxPainFromRows(rows, underlying) {
    if (!rows?.length) return null;

    const validRows = rows.filter(
      (r) => (r.CE?.oi || 0) > 0 || (r.PE?.oi || 0) > 0,
    );

    if (!validRows.length) return null;

    const strikes = validRows.map((r) => r.strike);

    let minPain = Infinity;
    let maxPainStrike = null;

    strikes.forEach((strike) => {
      let pain = 0;

      validRows.forEach((row) => {
        const s = row.strike;
        const ceOI = row.CE?.oi || 0;
        const peOI = row.PE?.oi || 0;

        if (strike > s) pain += (strike - s) * ceOI;
        if (strike < s) pain += (s - strike) * peOI;
      });

      if (pain < minPain) {
        minPain = pain;
        maxPainStrike = strike;
      }
    });

    return maxPainStrike;
  }
  const underlying = optionData?.data?.last_price ?? 0;
  const maxPain = calculateMaxPainFromRows(rows, underlying);

  const ceMaxRow = rows.find((r) => r.strike === maxPain)?.CE;
  const peMaxRow = rows.find((r) => r.strike === maxPain)?.PE;
  const ceMaxRowBuiltUp = getBuiltUp(ceMaxRow?.oiChange, ceMaxRow?.ltpPercent);

  const peMaxRowBuiltUp = getBuiltUp(peMaxRow?.oiChange, peMaxRow?.ltpPercent);

  const builtUpStyleCE = builtUpStyles(ceMaxRowBuiltUp);
  const builtUpStylePE = builtUpStyles(peMaxRowBuiltUp);

  const getPCRSentiment = (value) => {
    if (value < 0.7) return { label: "Bearish", color: "#ef4444" };
    if (value <= 1) return { label: "Neutral", color: "#9ca3af" };
    return { label: "Bullish", color: "#22c55e" };
  };

  const getCOIPCRSentiment = (value) => {
    if (value < 0.7) return { label: "Bearish", color: "#ef4444" };
    if (value <= 1) return { label: "Neutral", color: "#9ca3af" };
    return { label: "Bullish", color: "#22c55e" };
  };
  const green = "#22c55e";
  const red = "#ef4444";
  const grey = "#9ca3af";

  const getPCRColor = (v) => {
    if (v < 0.7) return red;
    if (v <= 1) return grey;
    return green;
  };

  const getStrengthColor = (v) => (v >= 0 ? green : red);

  const pcrSentiment = getPCRSentiment(pcr?.value);
  const coiSentiment = getCOIPCRSentiment(pcr?.coiPCR);

  useEffect(() => {
    // Load NIFTY by default on first visit
    if (!activeSymbol && !selectedIndex) {
      const defaultIndex = "NIFTY";

      setContract(defaultIndex);
      setSelectedIndex(defaultIndex);
      setActiveSymbol(defaultIndex);
      setLastFetchType("index");
      setSelectDropdown(true);
      // setSelectedStrike("");

      fetchByIndex(defaultIndex);
    }
  }, [activeSymbol, selectedIndex]);
  const handleExpiryChange = async (e) => {
    const expiry = e.target.value;

    // setSelectedStrike("");
    // setSelectDropdown(false);

    await setExpiry(expiry);
  };
  const BUILT_UP_META = {
    LB: {
      label: "Long Built-Up",
      signal: "Bullish",
      description: "Open Interest ↑ and Price ↑",
      color: "#008A3E",
      bg: "#D4F7E6",
    },
    SB: {
      label: "Short Built-Up",
      signal: "Bearish",
      description: "Open Interest ↑ and Price ↓",
      color: "#C53030",
      bg: "#FFE1E1",
    },
    SC: {
      label: "Short Covering",
      signal: "Bullish",
      description: "Open Interest ↓ and Price ↑",
      color: "#0047FF",
      bg: "#E6EEFF",
    },
    LW: {
      label: "Long Unwinding",
      signal: "Bearish",
      description: "Open Interest ↓ and Price ↓",
      color: "#C68A14",
      bg: "#FFF3CD",
    },
  };
  const ceBuiltUp = getBuiltUp(ceMaxRow?.oiChange, ceMaxRow?.ltpPercent);
  const peBuiltUp = getBuiltUp(peMaxRow?.oiChange, peMaxRow?.ltpPercent);

  const ceBuiltUpMeta = BUILT_UP_META[ceBuiltUp];
  const peBuiltUpMeta = BUILT_UP_META[peBuiltUp];
  const formatNumber = (num) => {
    if (num % 1 !== 0) {
      return num?.toFixed(2);
    }
    return num;
  };
  // const oiChartData = useMemo(() => {
  //   if (!rows?.length) return [];

  //   return rows.map((row) => ({
  //     strike: row.strike,
  //     callOI: row.CE?.oi || 0, // positive
  //     putOI: -(row.PE?.oi || 0), // negative
  //   }));
  // }, [rows]);
  // const oiChartData = useMemo(() => {
  //   if (!rows?.length) return [];

  //   const filtered = rows.filter(
  //     (r) => (r.CE?.oi || 0) > 0 || (r.PE?.oi || 0) > 0
  //   );

  //   return filtered.map((row) => ({
  //     strike: row.strike,
  //     strikeDiff: row.strike - maxPain,
  //     callOI: row.CE?.oi || 0,
  //     putOI: -(row.PE?.oi || 0),
  //     isMaxPain: row.strike === maxPain,
  //   }));
  // }, [rows, maxPain]);
  // const oiChartData = useMemo(() => {
  //   if (!rows?.length) return [];

  //   return rows
  //     .filter((r) => (r.CE?.oi || 0) > 0 || (r.PE?.oi || 0) > 0)
  //     .map((row) => ({
  //       strike: row.strike, // ✅ REAL STRIKE
  //       callOI: row.CE?.oi || 0,
  //       putOI: row.PE?.oi || 0,
  //       isMaxPain: row.strike === maxPain,
  //     }));
  // }, [rows, maxPain]);
  const oiChartData = useMemo(() => {
    if (!rows?.length) return [];

    return rows
      .filter(
        (row) => (row.CE?.oi || 0) > 0 || (row.PE?.oi || 0) > 0, // ✅ ONLY where OI exists
      )
      .map((row) => ({
        strike: row.strike, // ✅ REAL STRIKE
        callOI: row.CE?.oi || 0,
        putOI: row.PE?.oi || 0,
        isMaxPain: row.strike === maxPain, // ✅ highlight flag
      }));
  }, [rows, maxPain]);

  const displayInstrument =
    lastFetchType === "symbol" ? activeSymbol : contract;
  const navigate = useNavigate();
  useEffect(() => {
    if (!searchText || searchText.length < 2) {
      setResults([]);
      return;
    }

    const fetchSearch = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/search-stocks`, {
          params: { q: searchText },
        });

        setResults(res.data || []);
      } catch (err) {
        console.error("Search failed", err);
      }
    };

    fetchSearch();
  }, [searchText]);
  useEffect(() => {
    if (!symbol) return;

    getNameBySymbol(symbol);
  }, [symbol]);

  useEffect(() => {
    if (optionData) {
      setLastUpdated(formatTimestamp());
    }
  }, [optionData]);
  console.log("results:-", results);
  console.log("StockData", stockName);

  const handleStockSelect = async (item) => {
    const selectedSymbol =
      item?.underlyingSymbol || item?.underlying_symbol || item?.symbol;

    const selectedSecurityId = Number(
      item?.securityId ||
        item?.security_id ||
        item?.underlyingId ||
        item?.underlying_id,
    );

    if (!selectedSymbol) {
      console.error("Symbol missing:", item);
      return;
    }

    if (!Number.isInteger(selectedSecurityId) || selectedSecurityId <= 0) {
      console.error("Invalid security ID:", item);
      return;
    }

    const formattedSymbol = selectedSymbol.trim().toUpperCase();

    setSymbol(formattedSymbol);
    setActiveSymbol(formattedSymbol);

    // Store security ID here
    setActiveSecurityId(selectedSecurityId);

    setLastFetchType("symbol");
    setSelectedIndex("");
    setContract("");
    setSelectDropdown(false);

    setLocalSearch("");
    clearLocalResults();

    await Promise.all([
      fetchBySymbol({
        symbol: formattedSymbol,
        securityId: selectedSecurityId,
      }),
      getNameBySymbol(formattedSymbol),
    ]);
  };
  const handleRefresh = async () => {
    if (!activeSymbol || !lastFetchType) return;

    if (lastFetchType === "index") {
      await fetchByIndex(activeSymbol);
    } else {
      if (
        !Number.isInteger(Number(activeSecurityId)) ||
        Number(activeSecurityId) <= 0
      ) {
        console.error("Security ID missing for refresh:", activeSecurityId);
        return;
      }

      await Promise.all([
        fetchBySymbol({
          symbol: activeSymbol,
          securityId: Number(activeSecurityId),
        }),
        getNameBySymbol(activeSymbol),
      ]);
    }

    setLastUpdated(formatTimestamp());
  };
  return (
    <>
      <div className="back-export-files">
        <div className="back-btn">
          <button
            className="rec-btn trendpro-back-btn"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>
        <div className="last-updated-head">
          {lastUpdated && <span>As on {lastUpdated}</span>}
          <FiRefreshCw
            onClick={handleRefresh}
            size={18}
            style={{
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
          />
        </div>
      </div>
      <div
        className="option-chain-head max-pain-option"
        // style={{ display: "flex", justifyContent: "center" }}
      >
        <div className="select-option dropdown">
          <label className="max-label">Contracts</label>
          <select onChange={handleIndexSelect} value={selectedIndex}>
            <option value="">Select</option>
            {nseIndices.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <span className="select-span">OR</span>

        {/* <div className="search-option dropdown">
          <label className="max-label">Search Symbol</label>

          <div
            className="search-option-input"
            style={{
              borderRadius: "12px",

              display: "flex",
              alignItems: "center",
              padding: "0px 10px",
              background: "white",

              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
            }}
          >
            <input
              type="text"
              placeholder="Search Symbol"
              value={localSearch}
              onChange={(e) => {
                setLocalSearch(e.target.value);
              }}
              onKeyDown={handleKeyDown}
              className="search-option-chain"
              style={{
                padding: "14px",
                width: "150px",

                borderRadius: "20px",
                border: "none",
                outline: "none",
              }}
            />
            <span style={{ cursor: "pointer" }}>
              <CiSearch />
            </span>
            {localEquityResults?.length > 0 && (
              <div
                className="search-optionpage-dropdown"
                // style={{
                //   borderRadius: "12px",
                //   background: "white",
                //   display: "flex",
                //   alignItems: "center",
                //   padding: "0px 10px",
                //   boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
                //   position: "relative", // ✅ ADD THIS
                // }}
              >
               
                
                {localEquityResults.map((item, index) => {
                  const itemSymbol =
                    item?.underlyingSymbol ||
                    item?.underlying_symbol ||
                    item?.symbol;

                  const itemSecurityId =
                    item?.securityId ||
                    item?.security_id ||
                    item?.underlyingId ||
                    item?.underlying_id;

                  return (
                    <div
                      key={
                        item?.id || itemSecurityId || `${itemSymbol}-${index}`
                      }
                      className="search-option-dropdown-item"
                      onClick={() => handleStockSelect(item)}
                    >
                      <div className="dropdown-symbol">{itemSymbol}</div>

                      <div className="dropdown-company">
                        {item?.displayName ||
                          item?.display_name ||
                          item?.company ||
                          item?.companyName}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div> */}
        <div className="search-option dropdown">
          <label className="max-label">Search Symbol</label>

          <div
            className="search-option-input"
            style={{
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              padding: "0px 10px",
              background: "white",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
              position: "relative",
            }}
          >
            <input
              type="text"
              placeholder="Search Symbol"
              value={localSearch}
              onChange={(e) => setLocalSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Escape") {
                  clearLocalResults();
                }
              }}
              className="search-option-chain"
              style={{
                padding: "14px",
                width: "150px",
                borderRadius: "20px",
                border: "none",
                outline: "none",
              }}
            />

            <span style={{ cursor: "pointer" }}>
              <CiSearch />
            </span>

            {localSearchLoading && (
              <span
                style={{
                  fontSize: "12px",
                  marginLeft: "8px",
                }}
              >
                Searching...
              </span>
            )}

            {localEquityResults?.length > 0 && (
              <div className="search-optionpage-dropdown">
                <div className="search-section-title">Stocks</div>

                {localEquityResults.map((item, index) => {
                  const itemSymbol =
                    item?.underlyingSymbol ||
                    item?.underlying_symbol ||
                    item?.symbol;

                  const itemSecurityId =
                    item?.securityId ||
                    item?.security_id ||
                    item?.underlyingId ||
                    item?.underlying_id;

                  return (
                    <div
                      key={
                        item?.id || itemSecurityId || `${itemSymbol}-${index}`
                      }
                      className="search-option-dropdown-item"
                      onClick={() => handleStockSelect(item)}
                    >
                      <div className="dropdown-symbol">{itemSymbol}</div>

                      <div className="dropdown-company">
                        {item?.displayName ||
                          item?.display_name ||
                          item?.company ||
                          item?.companyName}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <div className="select-option dropdown">
          <label className="max-label">Expiry Dates</label>
          <select
            value={selectedExpiry || ""}
            onChange={handleExpiryChange} // ✅ SAME HANDLER
          >
            {expiries?.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>
      {loading && (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
            // color: "white",
            display: "flex",
            gap: "1rem",
          }}
        >
          Fetching Live data..{" "}
          <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <FaSpinner />
          </span>
        </p>
      )}
      {/* {!loading && error && (
        <div
          style={{
            marginTop: "20px",
            padding: "14px",
            borderLeft: "5px solid #dc2626",
            background: "#fee2e2",
            color: "#7f1d1d",
            fontWeight: 600,
            borderRadius: "8px",
          }}
        >
          ❌ {error}
        </div>
      )} */}
      {error && !loading && !optionData && (
        <div className="option-error">{error}</div>
      )}
      {!loading && pcr && (
        <>
          <div className="maxpain-container">
            <div
              className="grid-1 maxpain-grid"
              style={{
                // display: "flex",
                // flexDirection: "column",
                // width: "65%",
                gap: "10px",
                textAlign: "left",
                marginTop: "10px",
                boxShadow: "rgba(0, 0, 0, 0.4) 0px 4px 12px",
              }}
            >
              {/* <p>
              {lastFetchType === "index" ? <p>{stockData?.name}</p> : ""}
              <span>
                {lastFetchType === "index" ? "Contract" : ""}
                <span className="stock-tag" style={{ width: "max-content" }}>
                  {lastFetchType === "index" ? symbol : contract}
                </span>
              </span>
            </p> */}
              <p>
                {/* STOCK CASE */}
                {lastFetchType === "symbol" && (
                  <>
                    <span style={{ textAlign: "center" }}>
                      {stockName?.company}
                    </span>{" "}
                    <span>
                      <span
                        className="stock-tag"
                        style={{ width: "max-content", margin: "auto" }}
                      >
                        {activeSymbol}
                      </span>
                    </span>
                  </>
                )}

                {/* INDEX CASE */}
                {lastFetchType === "index" && (
                  <>
                    <span style={{ textAlign: "center" }}>Contract </span>
                    <span>
                      <span
                        className="stock-tag"
                        style={{ width: "max-content", margin: "auto" }}
                      >
                        {contract}
                      </span>
                    </span>
                  </>
                )}
              </p>

              <p style={{ textAlign: "center" }}>
                LTP
                <span>
                  <span
                    style={{
                      fontWeight: "700",
                      // color: "#00b3ff",
                      backgroundColor: " #e6f0ff",
                      color: " #0062ff",
                      padding: "4px 10px",
                      borderRadius: "8px",
                      width: "max-content",
                      margin: "auto",
                    }}
                  >
                    {" "}
                    {underlying}
                  </span>
                </span>
              </p>

              <p style={{ textAlign: "center" }}>
                Max Pain{" "}
                <span>
                  <span
                    style={{
                      fontWeight: "700",
                      background: "rgb(37, 99, 235)",
                      color: "white",

                      padding: "4px 10px",
                      borderRadius: "8px",
                      width: "max-content",
                      margin: "auto",
                    }}
                  >
                    {maxPain}
                  </span>
                </span>
              </p>
            </div>
          </div>

          <div>
            <MaxPainChart
              data={oiChartData}
              maxPain={maxPain}
              processed={rows}
              index={displayInstrument}
            />
          </div>

          <div className="ce-pe">
            <div className="ce-pe1">
              <div>
                <h3>Ltp ({maxPain} CE)</h3>

                <div
                  className="ce-pe2"
                  style={{
                    background:
                      ceMaxRow?.ltpPercent > 0 ? "#d4f7e6" : "#ffd4d4",
                    color: ceMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  {ceMaxRow?.ltp ?? "-"}{" "}
                  {ceMaxRow?.ltpPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ opacity: 0.8 }}>
                    {ceMaxRow?.ltpPercent !== undefined
                      ? ceMaxRow.ltpPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>

              <div className="sub-grid">
                <h3>Open Interest</h3>

                <div
                  className="ce-pe2"
                  style={{
                    background: ceMaxRow?.oiPercent > 0 ? "#d4f7e6" : "#ffd4d4",
                    color: ceMaxRow?.oiPercent > 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  {formatNumber(ceMaxRow?.oi) ?? "-"}{" "}
                  {ceMaxRow?.oiPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ opacity: 0.8 }}>
                    {ceMaxRow?.oiPercent !== undefined
                      ? ceMaxRow.oiPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>
              {/* Old code for built up */}
              {/* <div className="sub-grid">
                            <h3>Built Up</h3>
                            <div
                              className="ce-pe2"
                              style={{
                                backgroundColor: builtUpStyleCE.bg,
                                color: builtUpStyleCE.color,
                              }}
                            >
                              {ceMaxRowBuiltUp}
                            </div>
                          </div> */}
              <div className="sub-grid">
                <h3>Built Up</h3>

                <div
                  className="ce-pe2 builtup-box"
                  style={{
                    backgroundColor: ceBuiltUpMeta?.bg || "#f2f2f2",
                    color: ceBuiltUpMeta?.color || "#444",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  {ceBuiltUp}

                  {/* 🔹 Hover tooltip */}
                  {ceBuiltUpMeta && (
                    <div className="builtup-tooltip">
                      <strong>{ceBuiltUpMeta.label}</strong>
                      <div>{ceBuiltUpMeta.description}</div>
                      <div>
                        Signal:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            color:
                              ceBuiltUpMeta.signal === "Bullish"
                                ? "#008A3E"
                                : "#C53030",
                          }}
                        >
                          {ceBuiltUpMeta.signal}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="ce-pe1">
              <div>
                <h3>Ltp ({maxPain} PE)</h3>

                <div
                  className="ce-pe2"
                  style={{
                    background:
                      peMaxRow?.ltpPercent > 0 ? "#d4f7e6" : "#ffd4d4",
                    color: peMaxRow?.ltpPercent > 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  {peMaxRow?.ltp ?? "-"}{" "}
                  {peMaxRow?.ltpPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ opacity: 0.8 }}>
                    {peMaxRow?.ltpPercent !== undefined
                      ? peMaxRow.ltpPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>

              {/* OI box */}
              <div className="sub-grid">
                <h3>Open Interest</h3>

                <div
                  className="ce-pe2"
                  style={{
                    background: peMaxRow?.oiPercent > 0 ? "#d4f7e6" : "#ffd4d4",
                    color: peMaxRow?.oiPercent > 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  {formatNumber(peMaxRow?.oi) ?? "-"}
                  {peMaxRow?.oiPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ opacity: 0.8 }}>
                    {peMaxRow?.oiPercent !== undefined
                      ? peMaxRow.oiPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>
              {/* <div className="sub-grid">
                            <h3>Built Up</h3>
                            <div
                              className="ce-pe2"
                              style={{
                                backgroundColor: builtUpStylePE.bg,
                                color: builtUpStylePE.color,
                              }}
                            >
                              {peMaxRowBuiltUp}
                            </div>
                          </div> */}
              <div className="sub-grid">
                <h3>Built Up</h3>

                <div
                  className="ce-pe2 builtup-box"
                  style={{
                    backgroundColor: peBuiltUpMeta?.bg || "#f2f2f2",
                    color: peBuiltUpMeta?.color || "#444",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  {peBuiltUp}

                  {peBuiltUpMeta && (
                    <div className="builtup-tooltip">
                      <strong>{peBuiltUpMeta.label}</strong>
                      <div>{peBuiltUpMeta.description}</div>
                      <div>
                        Signal:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            color:
                              peBuiltUpMeta.signal === "Bullish"
                                ? "#008A3E"
                                : "#C53030",
                          }}
                        >
                          {peBuiltUpMeta.signal}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: "1.5rem" }}>
            <div className="grid call-grid" style={{ width: "50%" }}>
              <div className="sub-grid">
                <h3>Ltp ({maxPain} CE)</h3>

                <div
                  style={{
                    background:
                      ceMaxRow?.ltpPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                    color: ceMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                    marginTop: "15px",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {ceMaxRow?.ltp ?? "-"}{" "}
                  {ceMaxRow?.ltpPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ fontSize: "16px", opacity: 0.8 }}>
                    {ceMaxRow?.ltpPercent !== undefined
                      ? ceMaxRow.ltpPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>

              <div className="sub-grid">
                <h3>Open Interest</h3>
                <div
                  style={{
                    background:
                      ceMaxRow?.oiPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                    color: ceMaxRow?.oiPercent >= 0 ? "#008A3E" : "#C53030",
                    marginTop: "15px",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {formatNumber(ceMaxRow?.oi) ?? "-"}{" "}
                  {ceMaxRow?.oiPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ fontSize: "16px", opacity: 0.8 }}>
                    {ceMaxRow?.oiPercent !== undefined
                      ? ceMaxRow.oiPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>

              <div className="sub-grid">
                <h3>Built Up</h3>

                <div
                  className="ce-pe2 builtup-box"
                  style={{
                    backgroundColor: ceBuiltUpMeta?.bg || "#f2f2f2",
                    color: ceBuiltUpMeta?.color || "#444",
                    position: "relative",
                    cursor: "pointer",
                    marginTop: "10px",
                  }}
                >
                  {ceBuiltUp}

                  {/* 🔹 Hover tooltip */}
                  {ceBuiltUpMeta && (
                    <div className="builtup-tooltip">
                      <strong>{ceBuiltUpMeta.label}</strong>
                      <div>{ceBuiltUpMeta.description}</div>
                      <div>
                        Signal:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            color:
                              ceBuiltUpMeta.signal === "Bullish"
                                ? "#008A3E"
                                : "#C53030",
                          }}
                        >
                          {ceBuiltUpMeta.signal}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="grid call-grid" style={{ width: "50%" }}>
              <div className="sub-grid">
                <h3>Ltp ({maxPain} PE)</h3>

                <div
                  style={{
                    background:
                      peMaxRow?.ltpPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                    color: peMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                    marginTop: "15px",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {peMaxRow?.ltp ?? "-"}{" "}
                  {peMaxRow?.ltpPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ fontSize: "16px", opacity: 0.8 }}>
                    {peMaxRow?.ltpPercent !== undefined
                      ? peMaxRow.ltpPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>

              <div className="sub-grid">
                <h3>Open Interest</h3>
                <div
                  style={{
                    background:
                      peMaxRow?.oiPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                    color: peMaxRow?.oiPercent >= 0 ? "#008A3E" : "#C53030",
                    marginTop: "15px",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {formatNumber(peMaxRow?.oi) ?? "-"}
                  {peMaxRow?.oiPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ fontSize: "16px", opacity: 0.8 }}>
                    {peMaxRow?.oiPercent !== undefined
                      ? peMaxRow.oiPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>

              {/* <div className="sub-grid">
                                      <h3>Built Up</h3>
                                      <div
                                        style={{
                                          backgroundColor: builtUpStylePE.bg,
                                          color: builtUpStylePE.color,
                                          marginTop: "15px",
                                          padding: "10px 12px",
                                          borderRadius: "8px",
                                          fontWeight: "700",
                                          fontSize: "15px",
                                          display: "flex",
                                          gap: "10px",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        {peMaxRowBuiltUp}
                                      </div>
                                    </div> */}
              <div className="sub-grid">
                <h3>Built Up</h3>

                <div
                  className="ce-pe2 builtup-box"
                  style={{
                    backgroundColor: peBuiltUpMeta?.bg || "#f2f2f2",
                    color: peBuiltUpMeta?.color || "#444",
                    position: "relative",
                    cursor: "pointer",
                    marginTop: "10px",
                  }}
                >
                  {peBuiltUp}

                  {peBuiltUpMeta && (
                    <div className="builtup-tooltip">
                      <strong>{peBuiltUpMeta.label}</strong>
                      <div>{peBuiltUpMeta.description}</div>
                      <div>
                        Signal:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            color:
                              peBuiltUpMeta.signal === "Bullish"
                                ? "#008A3E"
                                : "#C53030",
                          }}
                        >
                          {peBuiltUpMeta.signal}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MaxPain;
